import type { Translate } from "../../providers/useTranslations";

export type SelectOptionType = {
  label: string;
  value: string;
};

export const daysArray = Array.from({ length: 31 }, (_item, i) => {
  return {
    value: i < 9 ? `0${i + 1}` : (i + 1).toString(),
    label: (i + 1).toString(),
  };
});

export const monthsArray = (translate: Translate) =>
  Array.from({ length: 12 }, (_item, i) => {
    const index = `${i + 1}`.padStart(2, "0");
    return {
      value: index,
      label: translate(`month.${index}`),
    };
  });

const DEFAULT_MIN_AGE = 18;
const currentYear = new Date().getFullYear();

export const yearsArray = (minAgeToRegister: string): Array<SelectOptionType> => {
  const minAge = parseInt(minAgeToRegister, 10) || DEFAULT_MIN_AGE;

  return customYearsArray(currentYear - 1899, -minAge);
};

export const customYearsArray = (rangeMinYear: number, rangeMaxYear: number): Array<SelectOptionType> => {
  const yearsArray: SelectOptionType[] = [];
  for (let i = currentYear + rangeMaxYear; i > currentYear - rangeMinYear; i--) {
    yearsArray.push({ value: i.toString(), label: i.toString() });
  }
  return yearsArray;
};

export const getNewDaysArray = (numberOfDays: number) => daysArray.slice(0, numberOfDays);
